import { useQuery } from '@tanstack/react-query';

import { Chain } from '~/components/Vendors/Chains/types';

import ReservationService from '~/services/ReservationService';

import { chainQueryKeys } from './useGetChains';

interface ChainResponse {
  status: number;
  result: Chain;
}

export function useGetChainById(chainId: string) {
  return useQuery<Chain>({
    queryKey: chainQueryKeys.detail(chainId),
    queryFn: async () => {
      const res: ChainResponse = await ReservationService.getChainById(chainId);
      return res.result;
    },
    enabled: !!chainId,
  });
}
